import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import WeightModal from './WeightModal';
import { Card, LogButton } from './common';

import rightArrow from '../../images/common/arrow-right-black.svg';
import AddIcon from '../../images/health-content/add-icon.svg';
import ClockIcon from '../../images/health-content/clock-icon.svg';
import WeightIcon from '../../images/health-content/weight-icon.svg';

const WeightCard = ({ weightCard, getData }) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState({
    showWeightModal: false,
  });

  return (
    <Card
      onClick={() => history.push('/health-content/weight-data')}
      className="w-half p-15 mt-2 health-card flex flex-col"
    >
      <div>
        <div className="flex justify-between w-full">
          <img src={WeightIcon} alt="weight-icon" />
          <img src={rightArrow} alt="right-arrow" className="w-6px" />
        </div>
        <h4 className="text-caption-l font-semibold mt-10">Weight</h4>
        <h1 className="text-title-l font-bold mt-1">
          {weightCard.current}
          <span className="text-button-l font-bold">kgs</span>
        </h1>
        <p className="text-sub text-caption-s">
          Recommended: &nbsp;
          <span className="text-primary font-medium text-caption-s ">
            {weightCard.goal}kgs
          </span>
        </p>
        <p className="font-medium text-chip text-sub mt-1">
          <img src={ClockIcon} alt="clock" className="inline" />
          &nbsp;{weightCard.updatedOn}
        </p>
      </div>
      <LogButton
        buttonText="Update"
        onClick={(e) => {
          setShowModal((prevState) => ({
            ...prevState,
            showWeightModal: true,
          }));
        }}
      />
      {showModal.showWeightModal && (
        <WeightModal
          hideModal={(e) => {
            if (e) e.stopPropagation();
            setShowModal((prevState) => ({
              ...prevState,
              showWeightModal: false,
            }));
          }}
          weightDate={weightCard}
          scaleVal={weightCard.current}
        ></WeightModal>
      )}
    </Card>
  );
};

export default WeightCard;
